import { BRAND_LOGO_URL, BRAND_NAME } from "./brand";

export function InflowHeader() {
  return (
    <header className="w-full px-5 py-4 sm:py-8">
      <div className="mx-auto block w-fit">
        <img
          src={BRAND_LOGO_URL}
          alt={`${BRAND_NAME} logo`}
          width={320}
          height={80}
          className="h-12 w-auto opacity-100 sm:h-24"
          fetchPriority="high"
          decoding="async"
        />
      </div>
    </header>
  );
}
